import { useState } from "react";

const MessageReplyModal = ({ message, onSend, onClose, sending }) => {
  const [replyText, setReplyText] = useState("");

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="mc-card p-6 w-full max-w-2xl">
        <h2 className="text-xl font-['Oswald'] font-bold text-white mb-4">SVAR PÅ BESKED</h2>
        <div className="bg-black/30 rounded-lg p-4 border border-white/10 mb-4">
          <p className="text-gray-400 text-sm">Fra: {message.name} ({message.email})</p>
          <p className="text-blue-400 font-medium">{message.subject}</p>
          <p className="text-gray-200 mt-2 whitespace-pre-wrap">{message.message}</p>
        </div>
        <textarea value={replyText} onChange={(e) => setReplyText(e.target.value)} className="mc-input w-full h-40 resize-none mb-4" placeholder="Dit svar..." />
        <div className="flex gap-3">
          <button onClick={() => onSend(message.message_id, replyText)} disabled={sending || !replyText.trim()} className="chrome-btn px-6 py-2 rounded-lg flex-1 disabled:opacity-50 flex items-center justify-center gap-2" data-testid="message-reply-send-btn">{sending ? <><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />Sender...</> : "Send"}</button>
          <button onClick={onClose} className="ghost-blue-btn px-6 py-2 rounded-lg">Annuller</button>
        </div>
      </div>
    </div>
  );
};

export default MessageReplyModal;
